module.exports = __webpack_public_path__ + "static/img/fund4.05982b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/fundClassify/fund4.png
// module id = C3yz
// module chunks = 0